import type { ReactNode } from 'react'

import { Page, PageHeader } from '@aeris/ui'

import { AssistantSettings } from '../components/assistant-settings.tsx'
import { AssistantToolCalls } from '../components/assistant-tool-calls.tsx'
import { ClaudeConnections } from '../components/claude-connections.tsx'

/**
 * Assistente (F253–F255), em Configurações: o que é DA LOJA.
 *
 * Quem conectou o Claude à loja, com o poder de desconectar (F253). Na F254
 * ganha o número do WhatsApp do assistente, as pessoas ligadas e o histórico
 * de perguntas; na F255, os horários do resumo do dia.
 */
export const AssistentePage = (): ReactNode => (
  <Page>
    <PageHeader
      title="Assistente"
      description="Quem pergunta os números da loja de fora do Aeris: pelo WhatsApp do assistente e pelo Claude."
    />
    <AssistantSettings />
    <ClaudeConnections everyone />
    <AssistantToolCalls />
  </Page>
)
